var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChatMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 105,
    viewBox: "0 0 117 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 63V72C36 77.5228 40.4772 82 46 82H102C107.523 82 112 77.5228 112 72V35C112 29.4772 107.523 25 102 25H87V46C87 55.3888 79.3888 63 70 63H36Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C9.47715 0 5 4.47715 5 10V47C5 52.5228 9.47715 57 15 57H71C76.5229 57 81 52.5228 81 47V10C81 4.47715 76.5229 0 71 0H15ZM21.5 14C19.567 14 18 15.567 18 17.5C18 19.433 19.567 21 21.5 21H64.5C66.433 21 68 19.433 68 17.5C68 15.567 66.433 14 64.5 14H21.5ZM18 27.5C18 25.567 19.567 24 21.5 24H50.5C52.433 24 54 25.567 54 27.5C54 29.433 52.433 31 50.5 31H21.5C19.567 31 18 29.433 18 27.5ZM21.5 34C19.567 34 18 35.567 18 37.5C18 39.433 19.567 41 21.5 41H59.5C61.433 41 63 39.433 63 37.5C63 35.567 61.433 34 59.5 34H21.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3647 43.6445C16.3647 41.3351 18.8647 39.8917 20.8647 41.0464L40.2091 52.2149C42.2091 53.3696 42.2092 56.2564 40.2092 57.4111L20.8647 68.5796C18.8647 69.7343 16.3647 68.2909 16.3647 65.9815L16.3647 43.6445Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.261 89.9805C100.261 92.2899 97.761 93.7333 95.761 92.5786L76.4166 81.4101C74.4166 80.2554 74.4166 77.3686 76.4166 76.2139L95.761 65.0454C97.761 63.8907 100.261 65.3341 100.261 67.6435L100.261 89.9805Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatMenu);
export default __webpack_public_path__ + "static/media/icon_chat-menu.70a1ff2d12e9a20b9d5971c72dc3d422.svg";
export { ForwardRef as ReactComponent };